var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.58824H4C3.44772 8.58824 3 8.14052 3 7.58824V3C3 2.44771 3.44772 2 4 2H17.0588C17.6111 2 18.0588 2.44772 18.0588 3V7.58824C18.0588 8.14052 17.6111 8.58824 17.0588 8.58824H16",
    stroke: "#00C087"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.38281,
    y: 5.32422,
    width: 10.2941,
    height: 12.1765,
    rx: 0.5,
    stroke: "#00C087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5312 13.7656L10.5313 9.05974",
    stroke: "#00C087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4102 11.8833L10.5278 13.7656L8.64545 11.8833",
    stroke: "#00C087",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWithdraw);
export default __webpack_public_path__ + "static/media/account-withdraw.04bd4d885705f53528e0c91da8fb2c95.svg";
export { ForwardRef as ReactComponent };